import { render } from "./ListAvatarCard.vue?vue&type=template&id=d5203672"
import script from "./ListAvatarCard.vue?vue&type=script&lang=js"
export * from "./ListAvatarCard.vue?vue&type=script&lang=js"

import "./ListAvatarCard.vue?vue&type=style&index=0&id=d5203672&lang=scss"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__